import React from 'react';
import Button from 'devextreme-react/button';
import { useScreenSize } from '../../../../../utils/media-query';

type Props = {
  onClose: () => void;
};

const StepSigned: React.FC<Props> = ({ onClose }) => {
  const { isXSmall } = useScreenSize();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div>Consentimiento firmado correctamente .</div>
      <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <Button text='Cerrar' onClick={onClose} />
      </div>
    </div>
  );
};

export default StepSigned;
